// extracted by mini-css-extract-plugin
var _1 = "downloadSvg_download-svg-label";
var _2 = "downloadSvg_download-svg-wrapper";
export { _1 as "download-svg-label", _2 as "download-svg-wrapper" }
